// Template constants for Integrable frontend

// Reserved words that cannot be used in template names
export const RESERVED_WORDS = [
  'whatsapp',
  'template',
  'message',
  'api',
  'meta',
  'facebook',
];

// Validation limits
export const VALIDATION_LIMITS = {
  NAME_MAX_LENGTH: 512,
  BUTTON_TEXT_MAX_LENGTH: 20,
  MAX_BUTTONS_PER_TEMPLATE: 10,
  MAX_EDITS_PER_MONTH: 10,
  EDIT_TIME_LIMIT_HOURS: 24,
  MAX_BODY_TEXT: 1024,
  MAX_HEADER_TEXT: 1024,
  MAX_FOOTER_TEXT: 1024,
  MAX_LIMITED_TIME_OFFER: 16,
  MAX_BUTTON_EXAMPLE: 15,
  MAX_BUTTON_URL_EXAMPLE: 2000,
  MAX_BUTTONS: 10,
};

// Dynamic variable patterns
export const DYNAMIC_VARIABLE_PATTERNS = {
  POSITIONAL: /\{\{\d+\}\}/g,
  NAMED: /\{\{[a-zA-Z_][a-zA-Z0-9_]*\}\}/g,
};

// Error messages
export const ERROR_MESSAGES = {
  TEMPLATE_NAME_REQUIRED: 'Template name is required',
  TEMPLATE_NAME_TOO_LONG: 'Template name must be less than 512 characters',
  TEMPLATE_NAME_INVALID:
    'Template name can only contain alphanumeric characters, underscores, and spaces',
  TEMPLATE_NAME_RESERVED: 'Template name cannot contain reserved words',
  CATEGORY_REQUIRED: 'Category is required',
  LANGUAGE_REQUIRED: 'Language is required',
  BODY_REQUIRED: 'Body text is required',
  BODY_TOO_LONG: 'Body text must be less than 1024 characters',
  HEADER_TEXT_REQUIRED: 'Header text is required for TEXT format',
  HEADER_URL_REQUIRED: 'Header URL is required for media formats',
  FOOTER_TOO_LONG: 'Footer text must be less than 1024 characters',
  LIMITED_TIME_OFFER_TOO_LONG:
    'Limited time offer text must be less than 16 characters',
  BUTTON_TEXT_REQUIRED: 'Button text is required',
  BUTTON_TEXT_TOO_LONG: 'Button text must be less than 20 characters',
  BUTTON_URL_REQUIRED: 'Button URL is required for URL type',
  BUTTON_PHONE_REQUIRED: 'Phone number is required for phone number type',
  BUTTON_EXAMPLE_REQUIRED: 'Button example is required for copy code type',
  BUTTON_EXAMPLE_TOO_LONG: 'Button example must be less than 15 characters',
  TOO_MANY_BUTTONS: 'Maximum 10 buttons allowed',
  AUTHENTICATION_RESTRICTIONS:
    'Authentication templates cannot have header, footer, limited time offer, or buttons',
  FOOTER_LIMITED_TIME_EXCLUSIVE:
    'Footer and limited time offer are mutually exclusive',
  DYNAMIC_VARIABLES_REQUIRED:
    'Dynamic variable examples are required when variables are present',
  INVALID_URL: 'Invalid URL format',
  INVALID_PHONE: 'Invalid phone number format',
  EDIT_PERMISSION_DENIED: 'You do not have permission to edit this template',
  EDIT_TIME_LIMIT_EXCEEDED: 'Template cannot be edited after 24 hours',
  EDIT_LIMIT_EXCEEDED: 'Monthly edit limit exceeded',
  TEMPLATE_NOT_FOUND: 'Template not found',
  NETWORK_ERROR: 'Network error occurred',
  VALIDATION_ERROR: 'Validation error occurred',
};

export default {
  RESERVED_WORDS,
  VALIDATION_LIMITS,
  DYNAMIC_VARIABLE_PATTERNS,
  ERROR_MESSAGES,
};
